import { INewBuilding } from '../../../types/newBuldings';
import { TViewMode } from '../../ProjectsOnMap/ProjectsOnMap';
import { formatPhoneNumber } from '@cian/newbuilding-utils';

interface IHandleNewbuildingPhone {
  mode: TViewMode;
  newbuilding: INewBuilding;
  onShowPhoneClick(): void;
}

export function handleNewbuildingPhone({ mode, newbuilding, onShowPhoneClick }: IHandleNewbuildingPhone) {
  // istanbul ignore if
  if (mode !== 'newBuildings') {
    return;
  }

  const callbackButton = document.getElementById(`${newbuilding.id}-phone`);

  // istanbul ignore else
  if (callbackButton) {
    callbackButton.onclick = () => {
      // Если номера не будет, то кнопка не отрендерится и условие выше не выполнится
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      const phone = formatPhoneNumber(newbuilding.phoneNumber!);
      const phoneNode = createPhoneNode(phone);

      callbackButton.replaceWith(phoneNode);
      onShowPhoneClick();
    };
  }
}

export function createPhoneNode(phone: string) {
  const span = document.createElement('span');
  span.textContent = phone;

  return span;
}
